const pattern = /^(\/|#|\?)/;

/**
 * Uses a regular expression to check whether the URL starts with
 * a forward slash (/), hash (#), or question mark (?)
 */
export const isRelativeUrl = (url: string) => pattern.test(url);
